<script>
import baseList from '@/views/components/base/baseList.vue'
import { Tag, Button } from 'view-design'
import Vue from 'vue'
export default {
  extends: baseList,
  components: {
  },
  data() {
    return {
      table: {
        mname: 'floor',
        key: 'id',
        url: {
          list: '/admin/system/floor/list',
          del:'/admin/system/floor'
        },
        output: false,
      },
      menus: [
        { label: '楼宇列表',name: "offices_building_list", },
        { label: '楼层列表', name: "offices_floor_list", },
      ],
      actions: [
        {
          label: "新增楼层",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
      ],
      filters: [
      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '楼层名称',
          key: 'floorName',
          width: 500,
          align: 'center',
        },
        {
          title: '备注',
          key: 'remark',
          width: 600,
          align: 'center',
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: [
            "edit",
            "delete",
          ],
          auth: {
            edit: "system/floor/edit",
            del: "system/floor/delete",
          },
        },
      ],
    }
  },
  created() {

  },
  methods: {
    toAdd() {
      $utils.url.push({ name: "offices_floor_edit", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "offices_floor_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
}
</script>
<style scoped></style>
